const withBrandPrefix = (prefix, config) => {
  return Object.entries(config).reduce((result, [key, values]) => {
    const prefixedValues = Object.entries(values).reduce((result, [key, value]) => {
      const prefixedKey = [prefix, key].filter((value) => !!value).join('-');
      result[prefixedKey] = value;
      return result;
    }, {});

    result[key] = prefixedValues;

    return result;
  }, {});
};

module.exports = withBrandPrefix;
